import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

// ════════════════════════════════════════════════════════════════════════
// SYSTEM CHECKS — "testler kosuyor mu, yesil mi?" (30 Agu 2026)
//
// 🔑 Serkan: *"Sorun olursa veya basarili gecerse super admin panelde
// notification ve mail ile haber ver."* Mail GitHub'dan gelir (kosu kirmizi
// olunca); BURASI "iyi haber"i ve — asil onemlisi — SESSIZLIGI gosterir.
//
// 🔑 NEDEN SESSIZLIK AYRI BIR DURUM: kosu hic olmadiginda ekran "kayit yok"
// der. Bu, "her sey yolunda" ile AYNI gorunurdu; oysa biri guvence, digeri
// guvencenin kaybi. Bu yuzden HAFTALIK kosu belirtilen gun sayisindan uzun
// suredir gorulmuyorsa satir AMBER olur ve bunu ISMIYLE soyler (Ilke 1).
//
// ⚠️ ESIK: 8 gun (haftalik kosu + 1 gun pay). Serkan'a soruldu, degistirilebilir.
// ════════════════════════════════════════════════════════════════════════

const HAFTALIK_ESIK_GUN = 8;

const RENK = { yesil:'var(--green)', kirmizi:'var(--red)', amber:'var(--orange)', gri:'var(--t3)' };

const yasGun = (iso) => (Date.now() - new Date(iso).getTime()) / 86400000;

const nekadarOnce = (iso) => {
  const dk = (Date.now() - new Date(iso).getTime()) / 60000;
  if (dk < 60) return `${Math.max(0, Math.round(dk))} min ago`;
  if (dk < 1440) return `${Math.round(dk / 60)} h ago`;
  return `${Math.round(dk / 1440)} d ago`;
};

const ETIKET = { bugun: 'TODAY', '1ay': '+1 MONTH', '3ay': '+3 MONTHS', '1yil': '+1 YEAR' };

export default function SystemChecks() {
  const [veri, setVeri] = useState(null);      // null = henuz okunmadi
  const [hata, setHata] = useState('');

  // 🔴 6 Eki 2026 (24 ay şartı, 2d-3 — Serkan A): son web / iOS / haftalık koşu eskiden SON 40 koşunun içinden
  //    aranıyordu. Her push bir web koşusu yazar; son haftalık koşudan beri 40'tan fazla push olunca haftalık koşu
  //    pencerenin dışında kalıyor ve kart YANLIŞLIKLA "WEEKLY RUN NOT SEEN" diyordu (iOS'un son koşusu da aynı yoldan
  //    kaybolabiliyordu). Şimdi her soru veritabanına AYRI sorulur (en son koşu = tek satır); haftalık koşunun dilimleri o
  //    koşunun ±1 saatinden okunur. "N failing run(s) in the last 40" satırı pencereyi adıyla söyler — o kalır.
  useEffect(() => {
    (async () => {
      const [son40, web, ios, haftalik] = await Promise.all([
        supabase.from('ci_runs').select('*').order('at', { ascending: false }).limit(40),
        supabase.from('ci_runs').select('*').or('suite.is.null,suite.eq.web').order('at', { ascending: false }).limit(1),
        supabase.from('ci_runs').select('*').eq('suite', 'ios').order('at', { ascending: false }).limit(1),
        supabase.from('ci_runs').select('*').or('suite.is.null,suite.eq.web').eq('mode', 'schedule')
          .order('at', { ascending: false }).limit(1),
      ]);
      // Okunamadiysa BOS LISTE gibi davranmayiz — "kayit yok" ile "okuyamadik"
      // ayri seylerdir (Ilke 1).
      const dusen = [son40, web, ios, haftalik].find(s => s.error);
      if (dusen) { setHata(dusen.error.message); setVeri({ runs: [], sonGenel: null, sonIos: null, sonHaftalik: null, sonTur: [] }); return; }
      const sonHaftalik = haftalik.data?.[0] || null;
      let sonTur = [];
      if (sonHaftalik) {
        // Haftalik kosunun her tarih dilimi ayri satir yazar; en son kosunun dilimlerini birlikte gosteririz.
        const t = new Date(sonHaftalik.at).getTime();
        const tur = await supabase.from('ci_runs').select('*').or('suite.is.null,suite.eq.web').eq('mode', 'schedule')
          .gte('at', new Date(t - 3600_000).toISOString()).lte('at', new Date(t + 3600_000).toISOString()).order('at', { ascending: false });
        if (tur.error) { setHata(tur.error.message); setVeri({ runs: [], sonGenel: null, sonIos: null, sonHaftalik: null, sonTur: [] }); return; }
        sonTur = tur.data || [];
      }
      setVeri({ runs: son40.data || [], sonGenel: web.data?.[0] || null, sonIos: ios.data?.[0] || null, sonHaftalik, sonTur });
    })();
  }, []);

  if (veri === null) return null;

  // 🔴 30 Agu 2026: takimlar AYRI okunur. Tek "son kosu" satiri birakilsaydi
  // iOS haftalik kostugunda web'in durumu ekrandan silinirdi (ya da tersi) —
  // kart, bakilmayan takimi "yok" degil "yolunda" gibi gosterirdi (Ilke 1).
  const { runs, sonGenel, sonIos, sonHaftalik, sonTur } = veri;
  const gecikti = !sonHaftalik || yasGun(sonHaftalik.at) > HAFTALIK_ESIK_GUN;
  const kirmizilar = runs.filter(r => !r.ok);
  // 🔴 7 Eki 2026 (Serkan A): haftalık ileri-tarih koşusunun bir dilimi FAIL iken başlık "ALL CHECKS PASSING" diyordu — aynı
  //    kutuda yeşil başlık + kırmızı "+3 MONTHS: FAIL" satırı. Ileri-tarih kırmızısı bugün kırık değil, gelecekte kırılacak bir
  //    şeyin ERKEN UYARISI → AMBER + "FUTURE-DATE RUN FAILING". Bugün kırık olan (son web / iOS koşusu) yine önce gelir (kırmızı).
  const haftalikKirmizi = !gecikti && sonTur.some(r => !r.ok);
  const bugunKirik = (sonGenel && !sonGenel.ok) || (sonIos && !sonIos.ok);

  const durumRengi = hata ? RENK.amber
    : gecikti ? RENK.amber
    : bugunKirik ? RENK.kirmizi
    : haftalikKirmizi ? RENK.amber
    : sonGenel ? RENK.yesil : RENK.amber;

  const durumMetni = hata ? 'CANNOT READ CHECK RESULTS'
    : !sonGenel ? 'NO RUNS RECORDED YET'
    : gecikti ? `WEEKLY RUN NOT SEEN FOR ${Math.round(yasGun(sonHaftalik ? sonHaftalik.at : new Date().toISOString()))} DAYS`
    : bugunKirik ? 'CHECKS FAILING'
    : haftalikKirmizi ? 'FUTURE-DATE RUN FAILING'
    : 'ALL CHECKS PASSING';

  return (
    <div data-testid="system-checks"
         style={{ border:`1px solid var(--border)`, borderRadius:8, background:'var(--bg2)',
                  marginBottom:16, overflow:'hidden' }}>
      <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px',
                    borderBottom:'1px solid var(--border)', background:'var(--bg3)' }}>
        <span style={{ width:9, height:9, borderRadius:9, background:durumRengi, flexShrink:0 }} />
        <span style={{ fontSize:10, fontWeight:700, letterSpacing:2, color:'var(--t2)' }}>SYSTEM CHECKS</span>
        <span style={{ fontSize:10, letterSpacing:1, color:durumRengi, fontFamily:'var(--mono)' }}>{durumMetni}</span>
      </div>

      <div style={{ padding:'10px 14px', fontSize:11, color:'var(--t2)', lineHeight:1.6 }}>
        {hata && (
          <div style={{ color:RENK.amber }}>
            The check results could not be read ({hata}). The runs may still be fine — this panel just cannot see them.
          </div>
        )}

        {!hata && !sonGenel && (
          <div style={{ color:RENK.amber }}>
            No test run has reported yet. Either the workflow has not run since it was added, or it cannot write here.
          </div>
        )}

        {!hata && sonGenel && (
          <>
            <div>
              Last run <b>{nekadarOnce(sonGenel.at)}</b> ({sonGenel.mode}
              {sonGenel.commit_sha ? ` · ${sonGenel.commit_sha}` : ''}) —{' '}
              <span style={{ color: sonGenel.ok ? RENK.yesil : RENK.kirmizi, fontWeight:700 }}>
                {sonGenel.ok ? 'PASSED' : 'FAILED'}
              </span>
              {sonGenel.passed != null && <> · {sonGenel.passed} tests</>}
            </div>

            {/* iOS TAKIMI — haftalik (macOS dakikalari 10 kat sayildigi icin
                her push'ta kosmuyor; Serkan'in karari, 30 Agu). */}
            <div style={{ marginTop:6 }}>
              <span style={{ fontSize:9, letterSpacing:1, color:'var(--t3)' }}>iOS SUITE</span>
              {sonIos ? (
                <div>
                  Last run <b>{nekadarOnce(sonIos.at)}</b> ({sonIos.mode}) —{' '}
                  <span style={{ color: sonIos.ok ? RENK.yesil : RENK.kirmizi, fontWeight:700 }}>
                    {sonIos.ok ? 'PASSED' : 'FAILED'}
                  </span>
                  {sonIos.passed != null && <> · {sonIos.passed} tests</>}
                  {!sonIos.ok && sonIos.failed_files && <> · <span style={{ fontFamily:'var(--mono)' }}>{sonIos.failed_files}</span></>}
                </div>
              ) : (
                // "Hic kosmadi" ile "yolunda" ayni gorunmesin.
                <div style={{ color:RENK.amber }}>Never reported. The weekly iOS run has not written here yet.</div>
              )}
            </div>

            {/* HAFTALIK GELECEK-TARIH KOSUSU: zaman bombasi avcisi. */}
            <div style={{ marginTop:8 }}>
              <span style={{ fontSize:9, letterSpacing:1, color:'var(--t3)' }}>WEEKLY FUTURE-DATE RUN</span>
              {gecikti ? (
                <div style={{ color:RENK.amber }}>
                  {sonHaftalik
                    ? `Last seen ${nekadarOnce(sonHaftalik.at)} — expected weekly. Check the workflow.`
                    : 'Never seen. Check that the scheduled workflow is enabled.'}
                </div>
              ) : (
                <div style={{ display:'flex', gap:14, flexWrap:'wrap', fontFamily:'var(--mono)', marginTop:2 }}>
                  {sonTur.map(r => (
                    <span key={r.id} style={{ color: r.ok ? RENK.yesil : RENK.kirmizi }}>
                      {ETIKET[r.label] || r.label}: {r.ok ? 'OK' : 'FAIL'}
                    </span>
                  ))}
                </div>
              )}
            </div>

            {kirmizilar.length > 0 && (
              <div style={{ marginTop:8, color:RENK.kirmizi }}>
                {kirmizilar.length} failing run(s) in the last {runs.length} (all suites):{' '}
                {kirmizilar.slice(0, 3).map(r => (
                  <span key={r.id} style={{ fontFamily:'var(--mono)' }}>
                    [{ETIKET[r.label] || r.label} {nekadarOnce(r.at)}
                    {r.failed_files ? ` — ${r.failed_files}` : ''}]{' '}
                  </span>
                ))}
                {sonGenel.run_url && (
                  <a href={sonGenel.run_url} target="_blank" rel="noreferrer"
                     style={{ color:'var(--accent)' }}>open in GitHub</a>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
